// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__2v0Aq","content":"ManualTimeModal_content__3YF57"};